export default "__VITE_ASSET__SJ5NsR$b__"